import { render, staticRenderFns } from "./ebu.vue?vue&type=template&id=2ebd3f00&scoped=true"
import script from "./ebu.vue?vue&type=script&lang=js"
export * from "./ebu.vue?vue&type=script&lang=js"
import style0 from "./ebu.vue?vue&type=style&index=0&id=2ebd3f00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd3f00",
  null
  
)

export default component.exports